package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.constants.StringConstants.MYSTERY_CHAR_ZWNBS
import com.eladfinish.bible.contest.constants.StringConstants.Regex.ALEF_TAV
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.splitByRegex

class GetFilteredMikudListUseCase {

    operator fun invoke(text: String): List<String> =
        listOf("כל הספר", "ספר", "תורה", "נביאים", "ראשונים", "אחרונים", "כתובים")
            .fold(text) { acc, item ->
                // not `\b$item\b`: JS RegExp's \b is ASCII-only (see WORD_CHAR)
                acc.replaceRegex(regex = "(?<!$WORD_CHAR)$item(?!$WORD_CHAR)", replacement = "")
            }
            .replaceRegex(regex = ".*" + "חידו[ןנ]" + ".*", replacement = "")
            .replaceRegex(regex = "" + MYSTERY_CHAR_ZWNBS.toChar().toString(), replacement = "")
            .trim()
            .replaceRegex(regex = "(.+)\r?\n", replacement = "$1.\n") // make line ends with a dot
            .replaceRegex(regex = "\\s+", replacement = " ") // remove duplicate spaces
            .replaceRegex(regex = "(פרקים|:)", replacement = ",")
            .replaceRegex(regex = "תהלים", replacement = "תהילים")
            .replaceRegex(regex = "(שמואל|מלכים|דברי הימים) א'-ב'", replacement = "$1 א, $1 ב")
            .replaceRegex(regex = "(שמואל|מלכים|דברי הימים) ([אב])'", replacement = "$1 $2")
            .replaceRegex(regex = "(ישעיה|ירמיה)([^ו])", replacement = "$1ו$2")
            .replaceRegex(regex = "(?<=,)(\\s?\\s?$ALEF_TAV),", replacement = "$1',")
            .replaceRegex(regex = "(\\s$ALEF_TAV)-", replacement = "$1'-")
            .replaceRegex(regex = "\"($ALEF_TAV)'?", replacement = "$1'")
            .replaceRegex(regex = "'", replacement = "")
            .splitByRegex(regexString = "[,/.\n]")
            .map { it.trim() }
            .filter { it.isNotEmpty() }
}
